const hasPreviews = message => Object.values(message.previews || {}).length > 0;

export default hasPreviews;
